import { defaultIconProps, IconSvgWrapper, type IconProps } from "./base";

const UploadIcon = (props: IconProps) => {
  props = { ...defaultIconProps, ...props };

  return (
    <IconSvgWrapper {...props}>
      <path
        className={`icon--${props.color}`}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7529 14.3275C20.1367 14.3277 20.4486 14.64 20.4727 15.0238V20.5316C20.4727 20.9156 20.1604 21.2279 19.7764 21.2279H4.26074C3.87674 21.2279 3.56445 20.9156 3.56445 20.5316V15.0238C3.56451 14.6398 3.87678 14.3275 4.26074 14.3275C4.64457 14.3276 4.95599 14.6399 4.95605 15.0238V19.6077C4.95605 19.7277 5.05285 19.8236 5.17285 19.8236H18.8408C18.9606 19.8234 19.0566 19.7276 19.0566 19.6077V15.0238C19.0567 14.6398 19.369 14.3275 19.7529 14.3275ZM11.5088 2.97591C11.7848 2.7001 12.2162 2.70008 12.4922 2.97591L16.6562 7.13997C16.9323 7.41597 16.9323 7.86006 16.6562 8.13607C16.3802 8.41187 15.9361 8.412 15.6602 8.13607L12.6963 5.1722V15.1683C12.6961 15.5521 12.3839 15.8636 12 15.8636C11.6163 15.8634 11.3049 15.552 11.3047 15.1683V5.1595L8.34082 8.12435C8.06485 8.40026 7.62044 8.39996 7.35645 8.13607C7.08046 7.86008 7.0805 7.41598 7.35645 7.13997L11.5088 2.97591Z"
      />
    </IconSvgWrapper>
  );
};

export default UploadIcon;
